export const MARKETING_INDUSTRY_ROUTE_PATHS = [
  '/apparel',
  '/footwear',
  '/bags-accessories',
  '/eyewear',
  '/jewelry-watches',
  '/packaging',
  '/furniture',
  '/beauty-personal-care',
  '/toys',
  '/sporting-goods',
] as const;

/** Only implemented pages reachable from the current marketing site. */
export const MARKETING_ROUTE_PATHS = [
  '/',
  '/pricing',
  '/contact',
  '/privacy',
  '/terms',
  ...MARKETING_INDUSTRY_ROUTE_PATHS,
] as const;

const RESERVED_MARKETING_ORGANIZATION_SLUGS = new Set<string>([
  'roles',
  // The public Your IMAI contact page (src/app/yourimai) shadows /[orgSlug].
  'yourimai',
  // Public Meta/OAuth data-deletion instructions (src/app/data-deletion).
  'data-deletion',
  ...MARKETING_ROUTE_PATHS.flatMap((path) => {
    const segments = path.split('/').filter(Boolean);
    return segments.length === 1 ? segments : [];
  }),
]);

export function isReservedMarketingOrganizationSlug(slug: string): boolean {
  return RESERVED_MARKETING_ORGANIZATION_SLUGS.has(slug);
}
